// extracted by css-extract-rspack-plugin
module.exports =  {"root":"d7dcba5c59","swiper-preloader-spin":"a6c8fd951f"};